// Modal
function modal(name, content, style, duration) {
	if (duration) {
		duration = duration + " ";
	} else {
		duration = "expires=0; ";
	}

	//Cookie helper
	var getCookie = function(name) {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		if (parts.length == 2)
			return parts
				.pop()
				.split(";")
				.shift();
	};

	// Only show modal if it hasn't been seen before by checking if cookie has been set.
	if (!getCookie("modal-" + name)) {
		// Add active states to body and modal. Also add unique name to modal.
		jQuery(".c-modal")
			.addClass("c-modal--active")
			.addClass("c-modal--name-" + name);
		jQuery("body").addClass("modal-active");

		// Add modal optional style state class.
		if (style) {
			jQuery(".c-modal").addClass(style);
		}
		jQuery(".c-modal__content").html(content);

		jQuery(document).on("click", ".modal-button", function(e) {
			e.preventDefault();

			var href = jQuery(".c-modal--name-" + name + " .modal-button").attr(
				"href"
			);

			if (duration) {
				//Set cookie to acknowledge the popup has been seen.
				document.cookie =
					"modal-" +
					name +
					"=acknowledged pop up; " +
					duration +
					"path=/";
			}
			if (href) {
				window.location.href = href;
			}
		});

		// Close modal
		jQuery(document).on(
			"click",
			".c-modal__close, .c-modal__button, .c-modal--name-" + name,
			function(e) {
				// Only fire when overlay and close button pressed.
				if (e.target == this) {
					// Remove Content and style state after modal has animated out.
					if (duration) {
						//Set cookie to acknowledge the popup has been seen.
						document.cookie =
							"modal-" +
							name +
							"=acknowledged pop up; " +
							duration +
							"path=/";
					}

					// Remove active states from body and modal.
					jQuery(".c-modal")
						.removeClass("c-modal--active")
						.addClass("c-modal--name-" + name);
					jQuery("body").removeClass("modal-active");

					setTimeout(function() {
						jQuery(".c-modal").removeClass(style);
						jQuery(".c-modal__content").html("");
					}, 1000);
				}
			}
		);
	}
}
